interface ProductImageHeightCalcProps {
	width: number
}

const ASPECT_RATIO_WIDTH = 5
const ASPECT_RATIO_HEIGHT = 7
const ASPECT_RATIO = ASPECT_RATIO_WIDTH / ASPECT_RATIO_HEIGHT

export const getImageHeight = ({ width }: ProductImageHeightCalcProps) =>
	Math.trunc(width / ASPECT_RATIO)
